export const businessBenefits = [
  {
    title: 'Appointments bookings',
    description:
      'Stay in control of your time, schedule sessions, and rebook or cancel appointments from our massage therapy scheduling tool for pets.',
  },
  {
    title: 'Client communications',
    description: 'Reduce no-shows, save time, and streamline repeat bookings with automated reminders and updates.',
  },
  {
    title: 'Services and locations for your massage therapy business',
    description: 'Manage your pet massage business and catalogue of therapy sessions online in one intuitive platform.',
  },
  {
    title: 'Staff, shifts and schedule management',
    description:
      'Add unlimited team members to schedule shifts, time off and services without the headache of extra admin.',
  },
];
